import { ArgsType, Field, Int } from '@nestjs/graphql'
import { IsOptional, MaxLength } from '@nestjs/class-validator'
import { bsConstants } from '../../module.constants'

/**
 * The Publisher Information tab's three buttons in one [sc-29190]: "Save note" sends a note, "Save note and
 * mark reviewed" a note (or none) and `reviewed: true`, and "Mark as not reviewed" `reviewed: false`.
 */
@ArgsType()
export class AdminUpdatePublisherApplicationArgs {
  @Field(t => Int)
  userId!: number

  @Field({ nullable: true })
  @IsOptional()
  @MaxLength(bsConstants.SUBSCRIPTIONS.PLANS.PUBLISHER.APPLICATION.NOTE_MAX_LENGTH)
  note?: string

  @Field({ nullable: true })
  reviewed?: boolean
}
